export type New<T> = new(...args: any[]) => T;

export type Mixin<T, M> = M | ((this: T & M) => M);

export function Mix<T, M1, M2, M3, M4, M5, M6, M7, M8>(t: (new(...args: any[]) => T), ...mixins: [
    (Mixin<T, M1>),
    (Mixin<T, M2>)?,
    (Mixin<T, M3>)?,
    (Mixin<T, M4>)?,
    (Mixin<T, M5>)?,
    (Mixin<T, M6>)?,
    (Mixin<T, M7>)?,
    (Mixin<T, M8>)?]
): New<T & M1 & M2 & M3 & M4 & M5 & M6 & M7 & M8> {

    class M extends (t as any) {
        constructor(...args: any[]) {
            super(...args);
            for (const m of mixins) {
                if (typeof m === "function") {
                    // @ts-ignore
                    m.call(this);
                }
            }
        }
    }

    for (const m of mixins) {
        if (!m) {
            throw new Error("Mixin is undefined");
        }
        for (const p of Object.getOwnPropertyNames(m)) {
            const d = Object.getOwnPropertyDescriptor(m, p)!;
            if (d.enumerable) {
                Object.defineProperty(M.prototype, p, d);
            }
        }
    }

    return M as any;
}

export function list<T, P>(elementFactory: (i: number, p?: P) => T): T[] & { elementFactory: (i: number, p?: P) => T } {
    const ar: T[] & { elementFactory: (i: number, p?: P) => T } = [] as any;
    ar.elementFactory = elementFactory;
    return ar;
}